import { authService } from '../../../services/auth.service.ts';
import type { Note } from '../types/note.types.ts';

const STORAGE_PREFIX = 'tbkmeet_notes_';

function storageKey(): string {
  const userId = authService.getUser()?.id ?? 'guest';
  return `${STORAGE_PREFIX}${userId}`;
}

function readAll(): Note[] {
  try {
    const raw = localStorage.getItem(storageKey());
    if (!raw) return [];
    const parsed = JSON.parse(raw) as Note[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(notes: Note[]): void {
  localStorage.setItem(storageKey(), JSON.stringify(notes));
}

export async function listNotes(): Promise<Note[]> {
  return readAll().sort((a, b) => b.updatedAt - a.updatedAt);
}

export async function getNote(id: string): Promise<Note | null> {
  return readAll().find((n) => n.id === id) ?? null;
}

export async function createNote(title = 'Adsız not'): Promise<Note> {
  const user = authService.getUser();
  const now = Date.now();
  const note: Note = {
    id: `note_${now}_${Math.random().toString(36).slice(2, 9)}`,
    title,
    content: '',
    ownerId: user?.id ?? 'guest',
    createdAt: now,
    updatedAt: now,
    starred: false,
  };
  const notes = readAll();
  notes.unshift(note);
  writeAll(notes);
  return note;
}

export async function updateNote(
  id: string,
  patch: Partial<Pick<Note, 'title' | 'content' | 'starred'>>
): Promise<Note | null> {
  const notes = readAll();
  const index = notes.findIndex((n) => n.id === id);
  if (index < 0) return null;

  notes[index] = {
    ...notes[index],
    ...patch,
    updatedAt: Date.now(),
  };
  writeAll(notes);
  return notes[index];
}

export async function deleteNote(id: string): Promise<void> {
  writeAll(readAll().filter((n) => n.id !== id));
}

export async function duplicateNote(id: string): Promise<Note | null> {
  const source = await getNote(id);
  if (!source) return null;

  const now = Date.now();
  const copy: Note = {
    ...source,
    id: `note_${now}_${Math.random().toString(36).slice(2, 9)}`,
    title: `${source.title} (kopya)`,
    createdAt: now,
    updatedAt: now,
    starred: false,
  };

  const notes = readAll();
  notes.unshift(copy);
  writeAll(notes);
  return copy;
}
